// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btnBox[data-v-e5490df4] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
